import LogoutIcon from '@/app/icons/LogoutIcon/LogoutIcon'
import { Dropdown } from 'flowbite-react'
import { MessageKeys, useTranslations } from 'next-intl'
import Link from 'next/link'
import React, { SVGProps } from 'react'
import { SecondaryButton } from '../SecondaryButton'

type Route = {
  title: string
  route: string
  icon?: React.FC<SVGProps<SVGSVGElement>>
  target?: string
}

type MenuSection = {
  title: string
  routes: Route[]
}

type HeaderMenuProps = {
  sections: MenuSection[]
  onLogout: () => void
  onClose?: () => void
  userInitials?: string
  userName?: string
  variant?: 'mobile' | 'dropdown'
}

export const HeaderMenu = ({
  sections,
  onLogout,
  onClose,
  userInitials,
  userName,
  variant = 'mobile',
}: HeaderMenuProps) => {
  const t = useTranslations('header')

  if (variant === 'dropdown') {
    return (
      <Dropdown
        label=""
        dismissOnClick={false}
        placement="bottom-end"
        className="!-left-6 mt-1 min-w-[240px]"
        renderTrigger={() => (
          <span className="hidden h-12 w-12 cursor-pointer items-center justify-center rounded-full bg-mydra-purple text-lg font-bold text-white md:flex">
            {userInitials}
          </span>
        )}
      >
        <Dropdown.Header>
          <div className="flex items-center gap-3">
            <span className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-mydra-purple text-sm font-bold text-white">
              {userInitials}
            </span>
            <span className="text-sm font-bold">{userName}</span>
          </div>
        </Dropdown.Header>
        {sections.map(({ routes }) =>
          routes.map(({ title, route, icon: Icon, target }, index) => (
            <Link
              href={route}
              className="focus:outline-none"
              key={index}
              target={target}
            >
              <Dropdown.Item
                icon={Icon}
                className="text-gray-light hover:bg-mydra-purple-light focus:bg-mydra-purple-light"
              >
                {t(title as MessageKeys<any, any>)}
              </Dropdown.Item>
            </Link>
          ))
        )}
        <Dropdown.Divider />
        <Dropdown.Item
          onClick={onLogout}
          icon={LogoutIcon}
          className="text-gray-light hover:bg-mydra-purple-light focus:bg-mydra-purple-light"
        >
          {t('logout')}
        </Dropdown.Item>
      </Dropdown>
    )
  }

  return (
    <div className="container flex flex-col gap-8 p-8">
      {sections.map(
        ({ title, routes }) =>
          routes?.length > 0 && (
            <React.Fragment key={title}>
              <div className="flex flex-col gap-4">
                <div className="text-sm font-semibold uppercase text-gray-light">
                  {t(title)}
                </div>
                {routes.map(({ title, route, icon: Icon, target }) => (
                  <Link
                    href={route}
                    className="focus:outline-none"
                    key={route}
                    target={target}
                    onClick={onClose}
                  >
                    <div className="flex items-center gap-4 text-base text-black">
                      {Icon && <Icon width={20} />}
                      <span>{t(title)}</span>
                    </div>
                  </Link>
                ))}
              </div>
              <div className="h-[1px] border-b border-lines"></div>
            </React.Fragment>
          )
      )}
      <SecondaryButton onClick={onLogout}>{t('logout')}</SecondaryButton>
    </div>
  )
}
